import React from 'react';
import NotificationBell from '../../../components/admin/NotificationBell';
import MessageNotificationBell from '../../../components/admin/MessageNotificationBell';

interface CalendarHeaderProps {
  onBlockTimeClick: () => void;
  onEditAvailabilityClick: () => void;
}

const CalendarHeader: React.FC<CalendarHeaderProps> = ({ onBlockTimeClick, onEditAvailabilityClick }) => {
  return (
    <div className="flex justify-between items-center mb-2">
      <h1 className="text-2xl font-semibold text-gray-800">Scheduling</h1>
      <div className="flex items-center gap-3">
        <MessageNotificationBell />
        <NotificationBell />
        <button
          onClick={onEditAvailabilityClick}
          className="px-4 py-2 bg-white text-[#3A5E63] border border-[#3A5E63] rounded-md hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-[#3A5E63]"
        >
          Edit Availability
        </button>
        <button
          onClick={onBlockTimeClick}
          className="px-4 py-2 bg-[#4A5568] text-white rounded-md hover:bg-[#2D3748] focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-[#2D3748]"
        >
          Block Time
        </button>
      </div>
    </div>
  );
};

export default CalendarHeader; 